import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';
import './footer4.css';

const Footer4 = (props) => {
  return (
    <footer className="footer4-footer7 thq-section-padding">
      <div className="footer4-max-width thq-section-max-width">
        <div className="footer4-credits">
          <div className="thq-divider-horizontal"></div>
          <div className="footer4-row">
            <img src='./Logo.png' className='logo' ></img>
            <div className="footer4-contact-info">
              <p><a href="mailto:info@skillconsultant.co.uk">info@skillconsultant.co.uk</a></p>
              <p>
                +44 7599 999136
              </p>

              <p>Harrow,  London,
                HA3 7EH
                United Kingdom</p>
            </div>
            <div className="footer4-social-icons">
              <a target="_blank" rel="noopener noreferrer">
                <img src='/facebook.png' ></img>
              </a>
              <a target="_blank" rel="noopener noreferrer">
                <img src='/insta.png' ></img>
              </a>
              <a target="_blank" rel="noopener noreferrer">
                <img src='/youtube.png' ></img>
              </a>
              <a
                href="https://wa.me/447599999136?text=Hello%2C%20I%20would%20like%20to%20inquire%20about%20your%20services."
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/whatsapp.png" alt="WhatsApp" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer4.propTypes = {
  cookiesLink: PropTypes.element,
};

Footer4.defaultProps = {
  cookiesLink: undefined,
};

export default Footer4;
